<template>
  <div class="leco-content">
    <transition appear mode="out-in">
      <div class="auth-page">
        <div class="container mt-4 mb-5">
          <div class="row">
            <!-------------------------------------------------------------------------------------------->
            <div
              v-if="userRegistStatus == 'Init'"
              class="col-md-6 offset-md-3 col-xs-12"
            >
              <h2 class="text-center mb-4">アカウントを作成</h2>
              <p class="text-xs-center"></p>
              <div v-if="errorMessages.length > 0" class="alert alert-danger">
                <ul>
                  <li v-for="msg in errorMessages" :key="msg">{{ msg }}</li>
                </ul>
              </div>
              <form @submit.prevent="singup">
                <p>アカウントの作成に必要な項目を入力してください。</p>
                <fieldset class="form-group">
                  <input
                    class="form-control form-control-lg last-name"
                    type="text"
                    v-model="family_name"
                    placeholder="Family name（Yamada）"
                  />
                  <input
                    class="form-control form-control-lg first-name"
                    type="text"
                    v-model="given_name"
                    placeholder="Name（Taro）"
                  />
                </fieldset>
                <fieldset class="form-group">
                  <input
                    class="form-control form-control-lg"
                    type="text"
                    v-model="email"
                    placeholder="Email"
                  />
                </fieldset>
                <fieldset class="form-group">
                  <input
                    class="form-control form-control-lg"
                    type="password"
                    v-model="password"
                    placeholder="Password"
                  />
                </fieldset>
                <fieldset class="form-group">
                  <input
                    class="form-control form-control-lg"
                    type="password"
                    v-model="passwordConfirm"
                    placeholder="Password again"
                  />
                </fieldset>
                <h6 class="text-left">
                  ※他のWebサービスで利用していないパスワードを設定してください。<br />
                  &nbsp;&nbsp;（10文字以上、英数、大文字、小文字、特殊文字を全て含む）
                </h6>
                <h6 class="text-left mb-4">
                  ※利用できる特殊文字『{{ usable_kigou }}』
                </h6>
                <button
                  class="btn btn-lg btn-outline-secondary float-right btn-execute"
                >
                  アカウント登録
                </button>
              </form>
            </div>
            <!-------------------------------------------------------------------------------------------->
            <div
              v-else-if="userRegistStatus == 'ConfirmationInput'"
              class="col-md-6 offset-md-3 col-xs-12"
            >
              <h2 class="text-center mb-4">認証コードを送信しました</h2>
              <p class="text-xs-center"></p>
              <div v-if="errorMessages.length > 0" class="alert alert-danger">
                <ul>
                  <li v-for="msg in errorMessages" :key="msg">{{ msg }}</li>
                </ul>
              </div>
              <form @submit.prevent="saveConfirmationCode">
                <p>
                  {{
                    email
                  }}に送信されたコードを入力して、このメールアドレスの認証を行ってください。
                </p>
                <fieldset class="form-group">
                  <input
                    class="form-control form-control-lg"
                    type="text"
                    v-model="confirmationCode"
                    placeholder="認証コード"
                  />
                </fieldset>
                <button
                  class="btn btn-lg btn-outline-secondary float-right btn-execute"
                >
                  次へ
                </button>
              </form>
            </div>
            <!-------------------------------------------------------------------------------------------->
            <div
              v-else-if="userRegistStatus == 'UserRegistComplete'"
              class="col-md-6 offset-md-3 col-xs-12"
            >
              <h2 class="text-center mb-4">アカウントが認証されました</h2>
              <p class="text-xs-center"></p>
              <div v-if="errorMessages.length > 0" class="alert alert-danger">
                <ul>
                  <li v-for="msg in errorMessages" :key="msg">{{ msg }}</li>
                </ul>
              </div>
              <form @submit.prevent="gotoLogin">
                <p>
                  メールアドレス「{{
                    email
                  }}」でアカウントの認証が完了しました。<br />
                  ログインするにはこのメールアドレスを使用してください。
                </p>
                <button
                  class="btn btn-lg btn-outline-secondary float-right btn-execute"
                >
                  ログイン画面へ
                </button>
              </form>
            </div>
          </div>
          <loading :active.sync="isPostLoading"></loading>
        </div>
      </div>
    </transition>
  </div>
</template>

<script scoped>
import axios from "axios";
import { mapState } from "vuex";
import { API_BASE_URL } from "@/common/config";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "RwvRegister",
  data() {
    return {
      userRegistStatus: "Init",
      email: "",
      family_name: "",
      given_name: "",
      password: "",
      passwordConfirm: "",
      confirmationCode: "",
      isPostLoading: false,
      errorMessages: [],
      usable_kigou:
        "^ $ * . [ ] { } ( ) ? \" ! @ # % & / \\ , > < ' : ; | _ ~ `",
      logger: this.$store.state.logger
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors
    })
  },
  components: {
    loading: Loading
  },
  methods: {
    singup() {
      this.errorMessages = [];

      // 必須入力チェック
      if (this.email == "") this.errorMessages.push("Eメールは必須項目です。");
      if (this.family_name == "") this.errorMessages.push("姓は必須項目です。");
      if (this.given_name == "") this.errorMessages.push("名は必須項目です。");
      if (this.password == "")
        this.errorMessages.push("パスワードは必須項目です。");
      if (this.passwordConfirm == "")
        this.errorMessages.push("パスワード（確認）は必須項目です。");
      if (this.errorMessages.length > 0) {
        return;
      }
      // パスワード一致チェック
      if (this.password != this.passwordConfirm) {
        this.errorMessages.push("パスワードが一致していません。");
        return;
      }

      // 姓名の長さチェック
      if (this.email.length > 128) {
        this.errorMessages.push(
          "Eメールアドレスは129文字以上に設定できません。"
        );
        return;
      }

      // メールアドレスの長さチェック
      this.logger.debug(this.family_name.length + this.given_name.length);
      if (this.family_name.length + this.given_name.length >= 32) {
        this.errorMessages.push("姓と名の合計は32文字以上に設定できません。");
        return;
      }

      // ローディングアイコン表示
      this.isPostLoading = true;

      // CognitoサインアップAPI実行
      this.$cognito
        .signUp(this.email, this.password, this.family_name, this.given_name)
        .then((result) => {
          // 登録に成功したら、確認コードの入力画面を表示
          this.logger.debug(JSON.stringify(result));
          this.isPostLoading = false;
          this.userRegistStatus = "ConfirmationInput";
        })
        .catch((err) => {
          // エラーなのでローディング非表示にする
          this.isPostLoading = false;

          if (err.code == "UsernameExistsException") {
            this.errorMessages.push("既にユーザーが登録されています。");
            return;
          } else if (err.message == "Invalid email address format.") {
            this.errorMessages.push("Eメールアドレスの形式が正しくありません");
            return;
          } else if (err.code == "InvalidParameterException") {
            this.errorMessages.push(
              "パスワードは以下を含むように設定してください。"
            );
            this.errorMessages.push("10文字以上");
            this.errorMessages.push("英字・数字を含む");
            this.errorMessages.push("大文字・小文字を含む");
            this.errorMessages.push("特殊文字（,.!@()'\"など）を含む");
            return;
          } else {
            this.logger.error("cognito.signUpで予期せぬエラーが発生しました。");
            this.logger.error(JSON.stringify(err));
            this.errorMessages.push(
              "サインアップに失敗しました。" + err.message
            );
            return;
          }
        });
    },
    saveConfirmationCode() {
      this.errorMessages = [];

      // 必須入力チェック
      if (this.confirmationCode == "") {
        this.errorMessages.push("リセットコードは必須項目です。");
        return;
      }

      // 確認コードのフォーマットチェック
      let re = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
      if (
        !re.test(this.confirmationCode) ||
        this.confirmationCode.length != 6
      ) {
        this.errorMessages.push("認証コードのフォーマットが正しくありません。");
        return;
      }

      // ローディングアイコン表示
      this.isPostLoading = true;

      // CognitoにEメールと確認コードで検証を行う
      let api_url =
        API_BASE_URL +
        "email-confirm?user_name=" +
        this.email +
        "&confirmation_code=" +
        this.confirmationCode;
      axios
        .get(api_url)
        .then((response) => {
          //statusCode==200以外は全部500のエラー画面に飛ばす
          if ("statusCode" in response.data) {
            if (response.data.statusCode == 200) {
              this.logger.info("Eメールと確認コードをチェック完了");
              this.logger.debug(JSON.stringify(response.data));
              this.isPostLoading = false;
              this.userRegistStatus = "UserRegistComplete";
            } else {
              this.logger.error(
                "Eメールと確認コードをチェックでstatusCode=200以外が返されました。statusCode=" +
                  response.data.statusCode
              );
              this.$router.push("/system-error500");
            }
          } else {
            this.logger.error(
              "Eメールと確認コードをチェックでstatusCodeが返されませんでした。" +
                response
            );
            this.$router.push("/system-error500");
          }
          this.mainLoading = false;
        })
        .catch((error) => {
          this.mainLoading = false;
          this.logger.error("Eメールと確認コードのチェックに失敗");
          this.logger.error(error);
          this.$router.push("/system-error500");
        });
    },
    gotoLogin() {
      this.$router.replace("/login");
    }
  }
};
</script>

<style scoped>
.first-name {
  width: 49%;
  float: right;
}

.last-name {
  width: 49%;
  float: left;
}

.page {
  margin-top: 1.5rem;
}

.btn-execute {
  width: 200px;
}

.dummyPass {
  position: absolute;
  left: -200vh;
}
</style>
